const actions = {
  SET_STATE: 'user/SET_STATE',
  CREATE: 'maillist/CREATE',
  EDIT: 'maillist/EDIT'
}

export default actions
